import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import { css } from "@emotion/css";
import BoxView from "./DrawerItemView/BoxView";
import BoxListView from "./DrawerItemView/BoxListView";
import { headerDrawerData } from "./HeaderDrawerDataList";
import SearchBar from "./searchbar";

function HeaderDrawer({
  activeName,
  handleClick,
  isVisible,
  current,
  onCancel,
}) {
  const themeDefault = useSelector((state) => state.themeDefault);
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  let themeValue = themeDefault?.info?.newConfig;
  const backgroundOverlay = css`
    // position: sticky;
    z-index: ${isVisible ? "999" : "0"};
    height: 100%;
    width: 100%;
    position: ${isVisible ? "fixed" : ""};
    backdrop-filter: blur(
      ${isVisible ? themeDefault?.info?.newConfig?.drawerbackDropBlur : ""}
    );
    left: 0;
    background-color: ${isVisible ? "rgb(0 0 0 / 14%)" : ""};
    transition: color 0.1s ease, background-color 0.6s ease-in-out,
      border 0.3s ease-in-out;
  `;
  const headerDrawerStyle = css`
    display: flex;
    position: absolute;
    justify-content: center;
    left: 0;
    right: 0;
    z-index: 1000;
    transition: display 0.3s ease-in-out, top 0.3s ease-in-out;
    top: ${isVisible ? "clamp(30px, 2.5vw, 50px)" : "-500px"};
    color: ${themeValue?.color};
    background: ${themeValue?.theme === "purple"
      ? "rgb(66 32 65 / 94%)"
      : themeValue?.theme === "default"
      ? "white"
      : themeDefault?.info?.newConfig?.backgroundAccentColor};
    backdrop-filter: blur(${themeValue?.cardBlur});
    border-bottom-right-radius: ${themeDefault?.info?.borderRadius}px;
    border-bottom-left-radius: ${themeDefault?.info?.borderRadius}px;
    padding: 30px 20px 20px 20px;
  `;

  const headerDrawerList = headerDrawerData(sharedUserInfo);
  const getLayoutStructure = (children) => {
    const count = children.length;
    let horizontalBoxes = [];
    let verticalBoxes = [];

    if (count <= 4) {
      horizontalBoxes = children;
    } else if (count > 4 && count <= 6) {
      horizontalBoxes = children.slice(0, 3);
      verticalBoxes = children.slice(3, count);
    } else if (count > 6 && count <= 8) {
      horizontalBoxes = children.slice(0, 2);
      verticalBoxes = children.slice(2, count);
    } else if (count > 8 && count <= 9) {
      horizontalBoxes = children.slice(0, 1);
      verticalBoxes = children.slice(1, count);
    } else if (count > 9 && count <= 12) {
      // horizontalBoxes = children.slice(0, 1);
      verticalBoxes = children.slice(0, count);
    }

    // Group the vertical boxes into groups of 3
    const groupedVerticalBoxes = verticalBoxes.reduce((acc, child, index) => {
      const groupIndex = Math.floor(index / 3);
      if (!acc[groupIndex]) {
        acc[groupIndex] = {
          id: groupIndex + 1,
          key: `col${groupIndex + 1}`,
          children: [],
        };
      }
      acc[groupIndex].children.push(child);
      return acc;
    }, []);

    return { horizontalBoxes, verticalBoxes: groupedVerticalBoxes };
  };
  return (
    <div className={backgroundOverlay}>
      <div id="drawer" className={headerDrawerStyle} onClick={handleClick}>
        <Row
          gutter={[12, 12]}
          style={{ width: "60%", display: "flex", justifyContent: "center" }}
        >
          {headerDrawerList &&
            headerDrawerList.length > 0 &&
            [...headerDrawerList]
              .filter((item) => item.show)
              .map((item, index) => {
                if (item.category === activeName && item.show) {
                  if (item.category === "ask max") {
                    return (
                      <SearchBar
                        key={item.id + index}
                        fromDrawer
                        onCancel={onCancel}
                      />
                    );
                  }
                  const { horizontalBoxes, verticalBoxes } = getLayoutStructure(
                    item.children.filter((s) => s?.show)
                  );
                  return (
                    <React.Fragment key={item.id + index}>
                      {" "}
                      {/* Ensure each Fragment has a unique key */}
                      {horizontalBoxes.map((subItem) => (
                        <BoxView
                          current={current}
                          key={subItem.id}
                          subItem={subItem}
                        />
                      ))}
                      {verticalBoxes.map((item, index) => {
                        return (
                          <Col
                            key={item.key} // Add a key prop here for each Col
                            span={6}
                            style={{
                              display: "flex",
                              // gap: "12px",
                              flexDirection: "column",
                              flexWrap: "wrap", // Allows wrapping
                              // justifyContent:,
                              gap: "15px",
                              // verticalBoxes[index]?.children?.length < 3
                              //   ? "15px"
                              //   : "0px",
                              justifyContent:
                                verticalBoxes[index]?.children?.length < 3
                                  ? "flex-start"
                                  : "space-between",
                              height: "100%", // Adjust as needed to control the height
                            }}
                          >
                            {item.children.map((subItem, index) => (
                              <BoxListView
                                key={subItem.id}
                                subItem={subItem}
                                current={current}
                                style={{
                                  width: "100%",
                                  marginBottom: index % 3 === 2 ? "12px" : "0", // Adds margin after every third item
                                }}
                              />
                            ))}
                          </Col>
                        );
                      })}
                    </React.Fragment>
                  );
                }
                return null; // Ensure to return null if no category matches
              })}
        </Row>
      </div>
    </div>
  );
}

export default HeaderDrawer;
